import { useParams } from 'react-router';

import { Card, ErrorCallout } from '../../shared';
import { Box, Flex } from '../../shared/components';
import { useAccount } from '../hooks/useAccount';

import { AccountHeading } from './AccountHeading';
import { SDKUsageTab } from './SDKUsageTab';

export function SDKUsageOverviewPage() {
  const { accountId } = useParams<{ accountId: string }>();
  const accountQuery = useAccount(accountId ?? '');

  if (!accountId) {
    return (
      <ErrorCallout>
        <strong>Invalid URL</strong>
        <p>Missing account ID in the URL.</p>
      </ErrorCallout>
    );
  }

  const account = accountQuery.data?.entities?.accounts?.[accountId];

  if (accountQuery.isLoading) {
    return (
      <div className="SDKUsageOverviewPage">
        <Flex>
          <Box width={1} p={2}>
            <Card>Loading account data…</Card>
          </Box>
        </Flex>
      </div>
    );
  }

  if (accountQuery.error || !account) {
    return (
      <div className="SDKUsageOverviewPage">
        <Flex>
          <Box width={1} p={2}>
            <Card>
              <ErrorCallout>
                <strong>Failed to load account data</strong>
                <p>Account not found or could not be loaded.</p>
              </ErrorCallout>
            </Card>
          </Box>
        </Flex>
      </div>
    );
  }

  return (
    <div className="SDKUsageOverviewPage">
      <AccountHeading account={account} />
      <SDKUsageTab account={account} />
    </div>
  );
}
